"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WallOfFrostAbilityHandler = exports.WallOfFrostActorAbilityFactory = exports.WallOfFrostAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class WallOfFrostAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.WallOfFrost;
        this.__typeName = "WallOfFrost";
    }
}
exports.WallOfFrostAbilityArgs = WallOfFrostAbilityArgs;
let WallOfFrostActorAbilityFactory = class WallOfFrostActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("WallOfFrost", "AllEnemies", 4);
    }
};
WallOfFrostActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("WallOfFrost")
], WallOfFrostActorAbilityFactory);
exports.WallOfFrostActorAbilityFactory = WallOfFrostActorAbilityFactory;
let WallOfFrostAbilityHandler = class WallOfFrostAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const level = container.getLevel(ability.invokerId);
        const focus = container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Focus);
        const reduceBy = Math.round(level * .5 * focus * .1);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                jitter: (0, Random_1.random)(25, 225),
                start: "front-hand",
                end: "chest",
                type: "IceComet",
                path: "line",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Frost", 160)
                ]
            })),
            onHit: (sequence, attack, damages, projectile) => {
                container.applyDebuff({
                    supernatural: true,
                    attackerId: ability.invokerId,
                    targetId: projectile.targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FrostDamageResistance, reduceBy),
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.DeathDamageResistance, reduceBy)
                    ], true),
                    sequence: sequence.pushSequence("sequential")
                });
            },
        });
    }
};
WallOfFrostAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.WallOfFrost)
], WallOfFrostAbilityHandler);
exports.WallOfFrostAbilityHandler = WallOfFrostAbilityHandler;
